export const MessagesConstants = {
  BULK_UPLOAD: {
    EMPTY_FILE:'This file seems to be empty',
    WRONG_FORMAT: 'Wrong file format. Please follow the template.',
    MESSAGE_EMAIL_DUPLICATE: 'The user is duplicated',
    EMAIL_WRONG_FORMAT: 'The email is not in the correct format',
    DATE_WRONG_FORMAT: 'Invalid date format',
    WEIGHT_WRONG_FORMAT: 'Invalid weight format',
    WEIGHT_REQUIRED: 'Weight is required',
    GENDER_REQUIRED: 'Gender is required',
    HEIGHT_FT_REQUIRED: 'Height FT is required',
    HEIGHT_IN_REQUIRED: 'Height IN is required',
    THROWING_ARM_REQUIRED: 'Throwing Arm is required',
    BATS_REQUIRED: 'Bats is required',
    PRIMARY_POSITION_REQUIRED: 'Primary Position is required',
    SECONDARY_POSITION_REQUIRED: 'Secondary Position is required',
    PLAYING_LEVEL_REQUIRED: 'Playing Level is required',
    SEASON_REQUIRED: 'Season is required',
    VALUE_REQUIRED: 'value is required',
    INVALID_FORMAT_NAME: (name: string) => `Invalid name format: ${name || 'blank'}`,
    INVALID_FORMAT_LAST_NAME: (name: string) => `Invalid Last name format: ${name || 'blank'}`,
    INVALID_FORMAT_EMAIL: (email: string) => `Invalid email format: ${email || 'blank'}`,
    ADD_PLAYER_DISABLED_BUTTON: 'There is a bulk upload in progress. Please wait until it finishes.',
  }
}
